import React from "react";
import { Card } from "antd";
import Tottenham from "../../../assets/Tottenham-Hotspur-Icon.png";

const tableDetails = [
  "Tottenham", "Tottenham", "Tottenham","Tottenham","Tottenham","Tottenham","Tottenham","Tottenham","Tottenham","Tottenham",
];

const Table = () => (
  <Card style={{padding: 20}}>
    <div className="table-header">
      <p className="font-bold text-lg">Pos.</p>
      <p className="font-bold text-lg">Team Name</p>
      <p className="font-bold text-lg">MP</p>
      <p className="font-bold text-lg">GD</p>
      <p className="font-bold text-lg">PTS</p>
    </div>
    <div>
      {tableDetails.map((item, index) => (
        <div key={index}>
          <TableBody pos={index++} />
        </div>
      ))}
      
    </div>
  </Card>
);

const TableBody = ({pos}) => (
  <div className="table-body mt-10 mb-10">
    <p className="font-bold text-lg">{pos}</p>
    <p className="font-bold text-lg"><img src={Tottenham} className="inline" /> Tottenham </p>
    <p className="font-bold text-lg">3</p>
    <p className="font-bold text-lg">3</p>
    <p className="font-bold text-lg">9</p>
  </div>
);



export default Table;